"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_FORECAST_TYPE = void 0;
// eslint-disable-next-line @typescript-eslint/class-name-casing
exports.PROJECT_FORECAST_TYPE = {
    TOTAL: { ID: 1, NAME: 'Project Total' },
    PARTIAL: { ID: 2, NAME: 'Project Partial' },
    VARIATION: { ID: 3, NAME: 'Variation' },
    RETENTION: { ID: 4, NAME: 'Retention' },
};
